import { css } from 'styled-system/css';

export const betSettingStyle = {
	textContent: css({
		base: {
			display: 'flex',
			justifyContent: 'flex-end',
			alignItems: 'center',
		},
		_mars: {
			p: '6px 0 12px 0'
		}
	}),
	button: css({
		base: {
			cursor: 'pointer',
			display: 'flex',
			alignItems: 'center',
			_hover: {
				color: 'var(--p500)'
			}
		}
	}),
	icon: css({
		base: {
			w: '20px',
			h: '20px'
		}
	})
};

